import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-1"}]]

const IconCircleLetterP = createReactComponent('outline', 'circle-letter-p', 'CircleLetterP', __iconNode);

export default IconCircleLetterP;